// extracted by mini-css-extract-plugin
export default {"externalAccess":"Kdn2L","heading":"TYvtJ","firstSection":"MuRoS","clarification":"Ppxeo","explanation":"MrH7G"};